import React, { useState, useEffect } from 'react';
import {
    MapPin,
    Building,
    MoreVertical,
    Edit,
    Phone,
    Mail,
    Trash2,
    User,
    SquarePen,
    Trash
} from 'lucide-react';

const Learner = ({ searchKey, idCustomer }) => {
    const [learners, setLearners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [dropdownOpen, setDropdownOpen] = useState(null);
    const [totalLearners, setTotalLearners] = useState(0);

    // Fonction pour récupérer les learners
    const fetchLearners = async () => {
        try {
            setLoading(true);
            setError(null);

            const response = await fetch('https://search.mg.formafusion.io/api/search/learners', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    key: searchKey,
                    idCustomer: idCustomer,
                }),
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const data = await response.json();

            setTotalLearners(data.learner_count || 0);

            setLearners(data.learners || []);
        } catch (error) {
            console.error('Erreur lors de la récupération des learners:', error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (searchKey, idCustomer) {
            fetchLearners();
        }
    }, [searchKey, idCustomer]);

    // Composant de chargement
    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="w-12 h-12 border-b-2 border-purple-600 rounded-full animate-spin"></div>
            </div>
        );
    }

    // Composant d'erreur
    if (error) {
        return (
            <div className="p-4 text-center text-red-500">
                <p>Erreur: {error}</p>
                <button
                    onClick={fetchLearners}
                    className="px-4 py-2 mt-2 text-white bg-purple-600 rounded hover:bg-purple-700"
                >
                    Réessayer
                </button>
            </div>
        );
    }

    // Aucun client trouvé
    if (!learners || learners.length === 0) {
        return (
            <div className="p-8 text-center text-gray-500">
                <Building className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                <p>Aucun apprenant trouvé.</p>
            </div>
        );
    }

    return (
        <div className="container mx-auto">
            <h1 className="mb-4 text-xl font-semibold">
                Vous avez {totalLearners} Apprenants
            </h1>
            <section id="content" className="p-2 mt-4">
                <div className="grid grid-cols-1 gap-4 showResult lg:grid-cols-2 md:grid-cols-2">
                    {learners.map((learner) => (
                        <div key={learner.id} class="grid w-full col-span-1 p-6 my-auto bg-white shadow-xl h-full rounded-xl">
                            <div class="flex flex-col justify-between w-full h-full gap-2">
                                <div class="flex items-center mb-4">
                                    <div class="">
                                        <div id="emp_photo_2503" class="flex items-center justify-center w-20 h-20 text-3xl font-medium text-gray-500 uppercase bg-gray-100 rounded-full">
                                            <img src={learner.photo} alt="" className='rounded-full' />
                                        </div>
                                    </div>
                                    <div class="ml-4">
                                        <p onclick="showEmployeUnique(2503, '/cfp/etp-drawers/apprenant/')" title="Randriamahefa Tsiry Vololona" class="text-lg cursor-pointer text-slate-900 font-semibold line-clamp-2 hover:underline">
                                            <span class="uppercase">{learner.name}</span> {learner.firstname}</p>
                                        <div class="mt-2">
                                            <p onclick="showCustomer(2405,'/cfp/etp-drawer/')" class="cursor-pointer text-slate-400 hover:underline line-clamp-2 etp_name_2503">
                                                {learner.etp_name}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>


            </section>
        </div>
    );
};

export default Learner;